export default "__VITE_ASSET__ByOkk5Ml__"